import React from 'react';
import Loadable from 'react-loadable';

import './WeaPlugin.less';

const loadable = (loader, loading = () => null) => Loadable({ loader, loading });
const WeaPlugin = loadable(() => import('./WeaPlugin'));

class Index extends React.Component {
  constructor(props) {
    super(props);
    const { location = {}, visible = false } = props;
    const { query = {} } = location;
    const { display = '' } = query;
    this.state = { display, visible };
  }

  render() {
    const { display, visible } = this.state;
    return display == 'page' || visible ? <WeaPlugin ecId={`${this && this.props && this.props.ecId || ''}_WeaPlugin@omh03k`} {...this.props} display={display} visible={visible} onShow={this.onShow} /> : null;
  }

  onShow = (visible = true) => {
    this.setState({ visible });
  };

  onHide = () => {
    this.setState({ visible: false });
  };
}

export default Index;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/components/wea-plugin/index.js